import { Hammer } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { PRACTICAL_ITEMS } from "../../data/site";
import { scrollToId } from "../../lib/contact";

export const PracticalTraining = () => (
  <section id="practical" data-testid="practical-section" className="py-24 sm:py-28 bg-navy relative overflow-hidden">
    <div className="absolute -bottom-32 -left-24 w-[440px] h-[440px] rounded-full bg-cyanx/10 blur-[130px]" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHead
        dark
        overline="Practical Training"
        title="Learn by Building, Not Just Watching"
        sub="The LaunchX program combines classroom learning with practical execution. Students work on real assignments in every phase."
      />
      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {PRACTICAL_ITEMS.map((item, i) => (
          <Reveal key={item} delay={(i % 4) * 0.05}>
            <div
              data-testid={`practical-item-${i + 1}`}
              className="group h-full bg-navy-800/70 border border-white/10 rounded-xl p-5 hover:border-cyanx/40 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex items-center justify-between">
                <Hammer size={14} className="text-cyanx/60 group-hover:text-cyanx transition-colors" />
                <span className="font-display font-bold text-xs text-white/15 group-hover:text-cyanx/40 transition-colors">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <p className="mt-3 text-sm font-medium text-slate-200 leading-snug">{item}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2} className="mt-12">
        <button
          data-testid="practical-cta"
          onClick={() => scrollToId("contact")}
          className="inline-flex items-center gap-2 bg-electric hover:bg-electric-dark text-white font-semibold text-sm rounded-full px-7 py-4 transition-all hover:-translate-y-0.5 hover:shadow-xl hover:shadow-electric/40"
        >
          Book Free Counselling
        </button>
      </Reveal>
    </div>
  </section>
);
